/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DescendantServiceAccountQuery {
    getFixupPrototypeFunction() { return DescendantServiceAccountQuery.fixupPrototype; }

    static newInstance(model: Partial<DescendantServiceAccountQuery>): DescendantServiceAccountQuery {
        let obj = Object.assign(new DescendantServiceAccountQuery(), model);
        DescendantServiceAccountQuery.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DescendantServiceAccountQuery>): DescendantServiceAccountQuery {
        if (!model) return null;
        return DescendantServiceAccountQuery.newInstance(<DescendantServiceAccountQuery> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DescendantServiceAccountQuery) {
        if (!obj) return;

        models.DescendantServiceAccountQuery.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DescendantServiceAccountQuery): boolean {
        Object.setPrototypeOf(obj, DescendantServiceAccountQuery.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service account IDs that belong to the ancestors of matching accounts.
     */
    service_account_ids: Array<string>;

    /**
     * Include the given service accounts in the result set
     */
    include_self: boolean;

    /**
     * Also include accounts whose billing_account_id matches any of the given accounts.
     */
    include_billing_as_parent: boolean;

    /**
     * Also include accounts whose resource_service_account_id matches any of the given accounts.
     */
    include_resource_as_parent: boolean;

    /**
     * Also include AWS GovCloud accounts whose commercial_account_id matches any of the given accounts.
     */
    include_commercial_as_parent: boolean;

    /**
     * Service account IDs to excluded with descendants.
     */
    exclude_service_account_ids: Array<string>;

}
